import React from 'react';
import PropTypes from 'prop-types';

const CloseSmall = props => (
  <svg
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title />
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.800000012"
    >
      <g
        id="Transactions-Payments-01"
        transform="translate(-618.000000, -184.000000)"
        fill={props.fill || '#434343'}
        fillRule="nonzero"
      >
        <g id="Group" transform="translate(554.000000, 177.000000)">
          <g
            id="back-arrow"
            transform="translate(69.000000, 12.000000) rotate(-360.000000) translate(-69.000000, -12.000000) translate(64.000000, 7.000000)"
          >
            <path
              d="M4.99997877,3.95786347 L1.25787389,0.215811761 L1.1964592,0.161351661 C0.890859822,-0.0719930941 0.477302227,-0.0456552577 0.215832618,0.215814351 C-0.0476282518,0.479275221 -0.0721692545,0.896832659 0.154761213,1.18868696 L0.204654687,1.24596444 L3.95735543,4.9999605 L0.215823794,8.74207161 L0.161019766,8.80392683 C-0.0516878384,9.08294126 -0.0497189521,9.45195433 0.154761213,9.7149354 L0.204654687,9.77221288 L0.277696657,9.83891951 C0.556711087,10.0516271 0.925724164,10.0496582 1.18870523,9.84517806 L1.24598271,9.79528459 L4.99997877,6.04153122 L8.74208365,9.78410925 L8.79859901,9.8346894 C9.10310661,10.0721085 9.52066405,10.0475675 9.78412492,9.78410666 L9.83470767,9.7275887 L9.87870552,9.66525901 C10.0677928,9.36809165 10.0300217,8.9879596 9.78412492,8.74206279 L6.0420758,4.99943419 L9.78413375,1.25784939 L9.83470767,1.20134027 C10.0721268,0.896832659 10.0475858,0.479275221 9.78412492,0.215814351 C9.49637245,-0.0719381171 9.02983352,-0.0719381171 8.74208106,0.215814351 L4.99997877,3.95786347 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

CloseSmall.propTypes = {
  fill: PropTypes.string,
};

export default CloseSmall;
